import util from '@bmp-vue/core/api/util'
const controller = 'Afagu'
const ctrl = Object.assign({}, util.GetCrud(controller, ['none']), {
  SavePropostaCampoAuxiliar (th) {
    const campos = []

    if ([null, undefined].indexOf(th.model.DtoConsultaMotor) < 0) { campos.push({ CodigoProposta: th.model.Codigo, NomeCampo: 'PROPOSTA_CONSULTAMOTOR', ValorCampo: JSON.stringify(th.model.DtoConsultaMotor) }) }

    return th.$api.Multiplo.Post('SavePropostaCampoAuxiliar', { dto: campos })
  },
  GetDocumento (th, tipoPessoa) {
    const list = [];
    if (tipoPessoa === th.$aux.TipoPessoaEnum.PF) {
      list.push({ text: 'RG - Frente', value: 13 })
      list.push({ text: 'RG - Verso', value: 14 })
      list.push({ text: 'CNH', value: 8 })
      list.push({ text: 'Comprovante Endereço', value: 6 })
      list.push({ text: 'Extrato Bancário', value: 23 })
    }
    return list
  },
  bureaus: [
    { id: 0, value: 'databusca', text: 'DATA BUSCA' },
    { id: 1, value: 'serasa', text: 'SERASA' },
    { id: 2, value: 'scr', text: 'SCR BACEN' },
  ],
  validaBureaus (th, documentoCliente, bureaus, callback) {
    var dtoDataBusca = {
      consulta: {
        Documento: documentoCliente,
      },
    }

    const dataAtual = th.$api.UI.Format.Date(
      th.$api.UI.Date.AddDay(new Date(), -45),
      'yyyy-MM'
    )

    var dataBaseAno = dataAtual.split('-')[0]
    var dataBaseMes = dataAtual.split('-')[1]
    var dtoScr = {
      consulta: {
        Documento: documentoCliente,
        DataBaseAno: dataBaseAno,
        DataBaseMes: dataBaseMes,
      },
    }

    var dtoSerasa = {
      consulta: {
        Documento: documentoCliente,
      },
    }
    Promise.all([
      !bureaus.databusca || bureaus.databusca.HasError ? th.$api.Multiplo.Post('ConsultaDataBusca', dtoDataBusca) : null,
      !bureaus.scr || bureaus.scr.HasError ? th.$api.Multiplo.Post('ConsultaSCR', dtoScr) : null,
      !bureaus.serasa || bureaus.serasa.HasError ? th.$api.Multiplo.Post('ConsultaSerasa', dtoSerasa) : null,
    ]).then(response => {
      bureaus.databusca = response[0] || bureaus.databusca
      bureaus.scr = response[1] || bureaus.scr
      bureaus.serasa = response[2] || bureaus.serasa
      th.$set(th.model, 'DadosBureau', bureaus);
      callback()
    })
  },
  ModeloCalculoEnum: {
    Price: 1,
    SAC: 2
  },
})

export default ctrl
